import * as types from '../actions/actionTypes';
import initialState from './initialState';
import _ from 'lodash';

export default function reducer(state = initialState.locations, action) {
    switch (action.type) {
        case types.LOAD_LOCATIONS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            })
        case types.LOAD_LOCATIONS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                errors: null,
                data: {
                    ...state.data,
                    ..._.mapKeys(action.payload.results, 'id')
                },
                count: action.payload.count,
                next: action.payload.next,
                previous: action.payload.previous,
            })
        case types.LOAD_LOCATIONS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: {
                    ...action.payload
                }
            })

        case types.ADD_LOCATION_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            })
        case types.ADD_LOCATION_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                errors: null,
                data: {
                    ...state.data,
                    [action.payload.id]: action.payload
                },
                count: state.count ? (state.count + 1) : 1,
            })
        case types.ADD_LOCATION_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: {
                    ...action.payload
                }
            })

        case types.UPDATE_LOCATION_REQUEST:
            return Object.assign({}, state, {
                isUpdating: true,
            })
        case types.UPDATE_LOCATION_SUCCESS:
            return Object.assign({}, state, {
                isUpdating: false,
                errors: null,
                data: {
                    ...state.data,
                    [action.payload.id]: action.payload
                },
            })
        case types.UPDATE_LOCATION_FAILURE:
            return Object.assign({}, state, {
                isUpdating: false,
                errorMessage: {
                    ...action.payload
                }
            })

        case types.DELETE_LOCATION_REQUEST:
            return Object.assign({}, state, {
                isDeleting: true,
            })
        case types.DELETE_LOCATION_SUCCESS:
            return Object.assign({}, state, {
                isDeleting: false,
                errors: null,
                data: _.omit(state.data, action.payload.id),
                count: state.count ? state.count - 1 : 0,
            })
        case types.DELETE_LOCATION_FAILURE:
            return Object.assign({}, state, {
                isDeleting: false,
                errorMessage: {
                    ...action.payload
                }
            })

        case types.RESET_ALL_INFO:
            return initialState.locations

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/locationsReducer.js